import { render, staticRenderFns } from "./fccObjetos.vue?vue&type=template&id=51bf8ef0"
import script from "./fccObjetos.vue?vue&type=script&lang=js"
export * from "./fccObjetos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports